/**Transforms the type of value data to the type of its form value */
export function typeTransform(value: any, formValue: any) {
  const valueType = typeof value;
  const formType = typeof formValue;
  if (valueType !== formType) {
    return parseType(formType, value);
  }
  return value;
}

/**Helper function for parsing the form type agaisnt the value type inside dynamic forms */
function parseType(
  formType:
    | 'string'
    | 'number'
    | 'bigint'
    | 'boolean'
    | 'symbol'
    | 'undefined'
    | 'object'
    | 'function',
  newValue: any
) {
  switch (formType) {
    case 'number':
      return parseInt(newValue);
    default:
      return newValue;
  }
}
